import { render, staticRenderFns } from "./SodiumAdded.vue?vue&type=template&id=6d71dbba&scoped=true"
import script from "./SodiumAdded.vue?vue&type=script&lang=ts"
export * from "./SodiumAdded.vue?vue&type=script&lang=ts"
import style0 from "./SodiumAdded.vue?vue&type=style&index=0&id=6d71dbba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d71dbba",
  null
  
)

export default component.exports